<script>
    export let name;
</script>

<h2>
    {#if name}
        {name}
    {/if}
</h2>

<style>
    h2 {
        min-height: 1em;
    }
</style>